import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, CircularProgress, Fab } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { updateUser } from '../../../actions/user';
import { useValue } from '../../../context/ContextProvider';

const UserActions = ({ params, rowId, setRowId }) => {
    const [loading, setLoading] = useState([false, false]); //Maneja el estado del circulo de espera en el icono seleccionado
    const [success, setSuccess] = useState(false);          //Si es true pone el icono de success, de otro modo pone el icon de grabar    
    const [rowState, setRowState] = useState(false);        //Activa o desactiva el icono de grabar
    const { state: { currentUser, users }, dispatch } = useValue();     //sirve para actualizar la tabla usuarios en borrado de registros
    const [okCancelValue, setOkCancelValue] = useState(null);

    const {id, name, email, tipoUsuario, habilitado} = params.row;

    const handleDelete = async() => {
        let result = null;
        setLoading([false, true]);
        try {
            result = await updateUser({cmd: 'CMD_DELETE', id, name, email, tipoUsuario, habilitado }, currentUser, dispatch);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Usuario borrado" } });    

            const newUsers = users.filter((user) => user.id !== id);
            //console.log({newUsers})
            dispatch({ type: 'UPDATE_USERS', payload: {rows: newUsers} });  //A users se envía el payload como {rows: valor}
        } catch (error) {
            
        }
        setLoading([false, false]);
    }
    
    useEffect(() => {
        if(params.id == rowId) {
            setRowState(true);
            setSuccess(false);
        }
        if(okCancelValue){
            //console.log('Respuesta de okCancelDialog: ', okCancelValue)
            
            if(okCancelValue.resp === 'ACEPTAR')
                handleDelete();
            
            
            
            setOkCancelValue(null);




            //dispatch({ type: 'UPDATE_OKCANCEL', payload: { open: false, title: null, message: null, respuesta: null, callerData: null} });
        }
    },[rowId, okCancelValue])

    const handleSubmit = async (comando) => {
        //const {id, name, email, tipoUsuario, habilitado} = params.row;
        //console.log('RowId: ', rowId);
        //console.log('NewRow: ', params.row);
        let result = null;

        if(comando === 'CMD_UPDATE'){
            setLoading([true, false]);
            result = await updateUser({cmd: 'CMD_UPDATE', id, name, email, tipoUsuario, habilitado }, currentUser, dispatch);
            setRowId(null);
            setRowState(false);
            setSuccess(true);
            setLoading([false, false]);
            /*setTimeout(() => {
                console.log("Delayed for 3 second.");
                setSuccess(false);
              }, "3000");
            */  
        }
        
        if(comando === 'CMD_DELETE'){
            if(rowId) {  //Hay un registro editado pendiente de grabar
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Para borrar un registro, primero guarde el registro editado por favor." } });
            } else {
                //Se requiere borrar el usuario
                await dispatch({ type: 'UPDATE_OKCANCEL', payload: { open: true, funcion: setOkCancelValue, title: 'Confirmar borrar', message: `Está seguro de borrar al usuario "${name}" (Id: ${id})?`, respuesta: false, callerData: id} });
            }
        }
   }

 
    return (
        <>
        <Box
            sx={{
                m: 1,
                position: 'relative',
            }}
        >
            {success ? (
                <Fab
                    color='primary'
                    sx={{
                        width: 36,
                        height: 36,
                        bgcolor: 'green',
                        '&:hover': { bgcolor: 'darkgreen' }
                    }}
                >
                    <CheckIcon />
                </Fab>
            ) : (
                <Fab
                    color='primary'
                    sx={{
                        width: 36,
                        height: 36,
                    }}
                    //disabled={params.id !== rowId || loading[0]} 
                    disabled={!rowState || loading[0]}
                    onClick={() => handleSubmit('CMD_UPDATE')}
                >
                    <SaveIcon />
                </Fab>
            )}
            {loading[0] && (
                <CircularProgress
                    size={48}
                    sx={{
                        color: 'green',
                        position: 'absolute',
                        top: -4,
                        left: -4,
                        zIndex: 1
                    }}
                />
            )}
        </Box>
         <Box
         sx={{
             m: 1,
             position: 'relative',
         }}
         >
            <Fab
                    
                    sx={{
                        width: 36,
                        height: 36,
                        boxShadow: 0,
                        bgcolor: '#E0E0E0',
                        color: '#A6A6A6',
                        '&:hover': { color: '#FFF', bgcolor: 'red', boxShadow: 1 }
                    }}
                    onClick={() => handleSubmit('CMD_DELETE')}
                >
                    <CancelIcon />
                </Fab>
                {loading[1] && (
                <CircularProgress
                    size={48}
                    sx={{
                        color: 'red',
                        position: 'absolute',
                        top: -4,
                        left: -4,
                        zIndex: 1
                    }}
                />
            )}
         </Box>
         </>
    )
}

export default UserActions